<template>
  <div class="update-page">
    <h1>Update Page {{id}}</h1>

    <form @submit.prevent="updatePage">
      <!-- Title Field -->
      <div class="form-group">
        <label for="title">Title:</label>
        <input
          id="title"
          type="text"
          v-model="pageData.title"
          class="form-control"
          required
        />
      </div>

      <!-- Path Field -->
      <div class="form-group">
        <label for="path">Path:</label>
        <input
          id="path"
          type="text"
          v-model="pageData.path"
          class="form-control"
        />
      </div>

      <!-- Slug Field -->
      <div class="form-group">
        <label for="slug">Slug:</label>
        <input
          id="slug"
          type="text"
          v-model="pageData.slug"
          class="form-control"
        />
      </div>

      <!-- HTML Content Field (with Codemirror editor) -->
      <div class="form-group">
        <label for="html_content">HTML Content:</label>
        <Codemirror
          v-model:value="pageData.html_content"
          :options="cmOptions"
          placeholder="Write your content here"
          :height="300"
          @change="changeHtmlContent"
        />
      </div>

      <!-- Status Field -->
      <div class="form-group">
        <label for="status">Status:</label>
        <select v-model="pageData.status" class="form-control" required>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      <!-- Submit Button -->
      <div class="form-group">
        <button type="submit" class="btn btn-primary">Update Page</button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import axios from "axios";
import Codemirror from "codemirror-editor-vue3";

// Import necessary Codemirror modules
import "codemirror/mode/htmlmixed/htmlmixed.js";
import "codemirror/theme/dracula.css";

export default {
  props:['id'],
  components: { Codemirror },
  setup(props) {
    // Model for the page data
    const pageData = ref({
      title: "",
      path: "",
      slug: "",
      html_content: "",
      status: "active",
    });

    // Codemirror options
    const cmOptions = ref({
      mode: "htmlmixed", // Use HTML mode
      theme: "dracula", // Theme
    });

    // Load page data when the component is mounted
    onMounted(() => {
      const pageId = props.id; // Replace with dynamic page ID from the route or store
      axios
        .get(`/dashboard/pages/${pageId}/update/`) // Your API endpoint to get the page data
        .then((response) => {
          pageData.value = response.data;
        })
        .catch((error) => {
          console.error("Error fetching page data:", error);
        });
    });

    // Handle changes to HTML content
    const changeHtmlContent = (value) => {
      pageData.value.html_content = value;
    };

    // Update page function to submit the form
    const updatePage = () => {
      const pageId = props.id; // Replace with dynamic page ID from the route or store
      axios
        .put(`/dashboard/pages/${pageId}/update/`, pageData.value) // API call to update the page
        .then((response) => {
          console.log(response)
          alert("Page updated successfully!");
        })
        .catch((error) => {
          console.error("Error updating page:", error);
          alert("There was an error updating the page.");
        });
    };

    return {
      pageData,
      cmOptions,
      updatePage,
      changeHtmlContent,
    };
  },
};
</script>

<style scoped>
.update-page {
  max-width: 800px;
  margin: 0 auto;
}

.form-group {
  margin-bottom: 15px;
}

.form-control {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
}

button {
  padding: 10px 20px;
}
</style>
